import { render, staticRenderFns } from "./PatientEditor.vue?vue&type=template&id=15ddba11&"
import script from "./PatientEditor.vue?vue&type=script&lang=ts&"
export * from "./PatientEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PatientEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports